import { FC } from 'react';
import { ReleaseAndDeployments } from '@agilelab/plugin-wb-builder-common';
import { Box, Typography, useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '@agilelab/plugin-wb-platform';
import { BookmarkIcon } from './icons/BookmarkIcon';

interface Props {
  release: ReleaseAndDeployments;
}

export const ReleaseName: FC<Props> = ({ release }) => {
  const theme = useTheme();
  const name = `v${release.metadata.version}`;

  return (
    <Box display="flex" alignItems="center" style={{ gap: '8px' }}>
      {release.metadata.isSnapshot && (
        <WbInfoTooltip
          title="This is a draft release"
          icon={
            <BookmarkIcon
              fontSize="small"
              style={{ color: theme.palette.accent.main }}
            />
          }
        />
      )}
      <Typography style={{ fontWeight: 700 }}>{name}</Typography>
    </Box>
  );
};
